import(/* webpackMode: "eager" */ "/opt/livekit-mod/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/opt/livekit-mod/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
;
import(/* webpackMode: "eager" */ "/opt/livekit-mod/node_modules/.pnpm/next@15.2.6_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/livekit-mod/node_modules/.pnpm/react-hot-toast@2.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/livekit-mod/styles/globals.css");
